import { Button, ButtonGroup, Paper, Typography } from '@mui/material'
import MarketGate from 'components/MarketGate'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dashboard2 from './Dashboard_2'

const ranges = [
  { label: '24 hours', value: '24h' },
  { label: '7 days', value: '7d' },
  { label: '30 days', value: '30d' },
  { label: 'All time', value: null },
]

export const DashboardWrapper = ({ second }: { second?: boolean }) => {
  const [range, setRange] = useState<string | null>('24h')
  const { t } = useTranslation()

  const changeRange = (val: typeof range) => () => {
    setRange(val)
  }
  return (
    <Paper sx={{ p: 4 }}>
      <Typography variant="h5" component="h2" mb={2} fontWeight={600}>
        {t('dashboard.applicationsData')}
      </Typography>

      <MarketGate
        key="dashboard"
        disableGateways
        Component={Dashboard2}
        componentProps={{ range }}
        allOption
        actions={
          <ButtonGroup variant="outlined" color="secondary">
            {ranges.map(item => (
              <Button
                key={`range-${item.value}`}
                sx={{ backgroundColor: range === item.value ? 'grey.200' : 'grey.50' }}
                onClick={changeRange(item.value)}
              >
                {item.label}
              </Button>
            ))}
          </ButtonGroup>
        }
      />
    </Paper>
  )
}
